import { sdkFactory } from './util/sdk';
import { isPayForOrder } from './util/woocommerce';
import $ from 'jquery';

class PayoneerPaymentFields {

	constructor( {
		sdk,
		paymentFieldsContainerId,
		paymentFieldsComponentAttribute,
	} ) {
		this.sdk = sdk;

		this.paymentFieldsContainerId = paymentFieldsContainerId;
		this.paymentFieldsComponentAttribute = paymentFieldsComponentAttribute;
	}

	setElement(element) {
		this.element = element;

		this.dropInContainer = this.element.querySelector(
			`.${this.paymentFieldsContainerId}`
		);

		this.dropInComponentName = this.dropInContainer.getAttribute(
			this.paymentFieldsComponentAttribute
		);
	}

	render() {
		if(!this.element) {
			throw new Error( 'render() called before element was set.' );
		}

		try {
			this.mount();
		} catch ( e ) {
			// eslint-disable-next-line no-console
			console.error( e );
			return false;
		}

		return true;
	}

	dropIn() {
		if ( this._dropIn ) {
			return this._dropIn;
		}

		if (
			! this.sdk
				.availableDropInComponents()
				.map( ( v ) => v.name )
				.includes( this.dropInComponentName )
		) {
			throw new Error(
				'Invalid dropIn component provided: ' + this.dropInComponentName
			);
		}

		return ( this._dropIn = this.sdk.dropIn( this.dropInComponentName, {
			hidePaymentButton: true,
		} ) );
	}

	mount() {
		const dropIn = this.dropIn();
		this.dropInContainer.innerHTML = '';

		dropIn.mount( this.dropInContainer );
	}

	unmount() {
		try {
			this.dropIn().unmount();
		} catch(e) {
			// eslint-disable-next-line no-console
			console.error( e );
		}
	}

	pay() {
		//Reloading sdk before pay() ensures we catch list session expiration
		this.sdk.reload();
		this.dropIn().pay();
	}
}

export default PayoneerPaymentFields;
